'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * @since 2017-03-30 13:26:18
 * @author vivaxy
 */

var getPageDataAndAttr = exports.getPageDataAndAttr = function getPageDataAndAttr(page) {
    if (page) {
        try {
            // lxAttr 是空对象，则重新申请 pageid 和 cid
            var _JSON$parse = JSON.parse(page.data || '{}'),
                _JSON$parse$data = _JSON$parse.data,
                data = _JSON$parse$data === undefined ? [] : _JSON$parse$data,
                _JSON$parse$pageAttr = _JSON$parse.pageAttr,
                pageAttr = _JSON$parse$pageAttr === undefined ? [] : _JSON$parse$pageAttr,
                _JSON$parse$lxAttr = _JSON$parse.lxAttr,
                lxAttr = _JSON$parse$lxAttr === undefined ? {} : _JSON$parse$lxAttr;

            return { data: data, pageAttr: pageAttr, lxAttr: lxAttr };
        } catch (ex) {}
    }
    return { data: [], pageAttr: [], lxAttr: {} };
};

/**
 * update url according to https://wiki.sankuai.com/pages/viewpage.action?pageId=728754901
 * @param {Object} options
 * @returns {Promise.<[{}]>}
 */

exports.default = function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(options) {
        var fetch, url, serviceId, platform, pageTemplateData, getPageByServiceIdParams, params, fetchResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        fetch = options.fetch, url = options.url, serviceId = options.serviceId, platform = options.platform, pageTemplateData = options.pageTemplateData, getPageByServiceIdParams = options.getPageByServiceIdParams;
                        params = getPageByServiceIdParams();
                        _context.next = 4;
                        return fetch({
                            url: url,
                            data: _extends({
                                serviceId: serviceId,
                                platform: platform
                            }, params)
                        });

                    case 4:
                        _context.t0 = _context.sent;

                        if (_context.t0) {
                            _context.next = 7;
                            break;
                        }

                        _context.t0 = [];

                    case 7:
                        fetchResult = _context.t0;


                        if (fetchResult.length === 0 && pageTemplateData.length >= 1) {
                            fetchResult = pageTemplateData; // poi商户空页面，去生成一个默认模版页面；
                        }

                        return _context.abrupt('return', fetchResult.map(function (item) {
                            var _getPageDataAndAttr = getPageDataAndAttr(item),
                                data = _getPageDataAndAttr.data,
                                pageAttr = _getPageDataAndAttr.pageAttr,
                                lxAttr = _getPageDataAndAttr.lxAttr;

                            return _extends({}, item, { data: data, pageAttr: pageAttr, lxAttr: lxAttr });
                        }));

                    case 10:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function (_x) {
        return _ref.apply(this, arguments);
    };
}();


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/api/getPageByServiceId.js
// module id = 215
// module chunks = 0